let t=0;const e=()=>t++;export{e as uid};
//# sourceMappingURL=uid.min.mjs.map
